import { get } from 'sortablejs'
import api from '../http'
interface ObjParams {
	[propName: string]: any
}
export default {
	login(params: ObjParams) {
		return api.post('/api/user/login', params).then((resp: ObjParams) => {
			return resp
		})
	},
	logout() {
		return api.get('/api/user/logout').then((resp: ObjParams) => {
			return resp
		})
	},
	// 用户列表
	getUserList(data: ObjParams) {
		return api.post('/api/user/list', data).then((resp: ObjParams) => {
			return resp
		})
	},
	// 删除
	deleteUser(data: ObjParams) {
		return api.get('/api/user/delete', { params: data }).then((resp: ObjParams) => {
			return resp
		})
	},
	//编辑
	editUser(params: ObjParams) {
		return api.post('/api/user/save', params).then((resp: ObjParams) => {
			return resp
		})
	},
	//导出数据
	exportData(params: ObjParams) {
		return api.get('/api/user/exportUserList', { params, responseType: 'blob' }).then((resp: ObjParams) => {
			return resp
		})
	},
	//系统账号 - 列表
	getSystemList(data: ObjParams) {
		return api.post('/api/user/accountList', data).then((resp: ObjParams) => {
			return resp
		})
	},
	//系统账号 - 保存
	saveSystemList(data: ObjParams) {
		return api.post('/api/user/accountSave', data).then((resp: ObjParams) => {
			return resp
		})
	},
	// 获取用户信息
	getUserInfo(data: ObjParams) {
		return api.get('/api/user/accountBySysName', { params: data }).then((resp: ObjParams) => {
			return resp
		})
	},
	//听风者网络视频监测系统token
	getToken() {
		return api.get('/api/user/getTJToken').then((resp: ObjParams) => {
			return resp
		})
	},
	//检查是否登录
	checkLogin() {
		return api.get('/api/user/isLogin').then((resp: ObjParams) => {
			return resp
		})
	}
}